import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AutoForm from "../../../elements/form";
import { Row, RowContainer } from "../../../styles/containers/styles";
import { PageHead } from "../../../styles/headings";
import Layout from "../../common/layout";
import { Concern, Concerns, Type, CheckBox, Label, ContactDetail, ContactTop, BackButton } from "./styels";
import { useTranslation } from "react-i18next";
import { changeSelectedConcern, fetchContactConcerns } from "../../../../store/actions/contact";
import { postData } from "../../../../backend/api";
import { ContactLargeIcon, GetIcon, TickIcon } from "../../../../icons";
import moment from "moment";
import withLayout from "../../../public/layout";
import { Header, Overlay, Page } from "../../../elements/form/styles";
import { Button } from "../../../elements/input/styles";
import { useNavigate } from "react-router-dom";
const Contact = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [attributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      validation: "",
      default: "",
      showItem: "firstName",
      label: "firstName",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      validation: "",
      default: "",
      label: "lastName",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "Position",
      name: "position",
      validation: "",
      default: "",
      label: "Position",
      required: true,
      view: true,
      add: true,
      update: true,
      customClass: "full",
      apiType: "JSON",
      selectApi: [
        { id: "CEO", value: t("CEO (Chief Executive Officer)") },
        { id: "HR Manager", value: t("HR Manager") },
        { id: "Admin/Operations Manager", value: t("Admin/Operations Manager") },
        { id: "Finance Manager/Accountant", value: t("Finance Manager/Accountant") },
        { id: "Department Manager", value: t("Department Manager") }
      ],
      filter: false,
    },
    {
      type: "text",
      placeholder: "contactCompany",
      name: "company",
      validation: "",
      default: "",
      label: "contactCompany",
      required: true,
      view: true,
      add: false,
      update: false,
      customClass: "full",
    },
    {
      type: "text",
      placeholder: "email",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      upload: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      customClass: "full"
    },
    {
      type: "select",
      placeholder: "select",
      name: "companySize",
      validation: "",
      default: "",
      label: "Company size",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: "0 - 15", value: t("0 - 15") },
        { id: "15 - 30", value: t("15 - 30") },
        { id: "30 - 100", value: t("30 - 100") },
        { id: "100 - 500", value: t("100 - 500") },
        { id: "500 - 1000", value: t("500 - 1000") },
        { id: "1000+", value: t("1000+") },
      ],
      filter: false,
      customClass: "full"
    },
    // {
    //   type: "text",
    //   placeholder: "telephone",
    //   name: "phone",
    //   default: "",
    //   validation: "mobile",
    //   label: "telephone",
    //   required: true,
    //   view: true,
    //   add: false,
    //   update: false,
    // },
    {
      type: "text",
      placeholder: "country",
      name: "country",
      validation: "",
      default: "",
      label: "country",
      required: true,
      filter: false,
      view: false,
      tag: true,
      add: true,
      update: true,
      customClass: "full"
    },
    {
      type: "textarea",
      placeholder: "description",
      name: "description",
      validation: "",
      default: "",
      label: "description",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("contact")} - Whistleblowing24`;
  }, [t]);
  //dispatch is using to update the state in store
  const dispatch = useDispatch();

  const themeColors = useSelector((state) => state.themeColors);
  // const concerns = useSelector((state) => state.contactConcers);
  // const selectedConcern = useSelector((state) => state.selectedConcern);
  const [type, setType] = useState(null);
  const [clearForm, setClearForm] = useState(false);
  // const [initialFormInout, setInitialFormInout] = useState([]);
  // const [formInput, setFormInput] = useState(initialFormInout);
  const submitChange = async (post, fields) => {
    try {
      props.setLoaderBox(true);
      // await SendEmail(post);
      await postData(post, "contact")
        .then((response) => {
          if (response.status === 200) {
            props.setMessage({ type: 1, content: t("contact-form-submit"), proceed: "Thank you!", code: 200 });
            setType(null);
            setClearForm(true);

            // setFormInput(initialFormInout);
          } else {
            props.setMessage({ type: 1, content: t("somethingWrong"), proceed: "Try Again", code: 500 });
          }
          props.setLoaderBox(false);
        })
        .catch((error) => {
          props.setMessage({ type: 1, content: t("serverError"), proceed: "Try Again", code: 500 });
          props.setLoaderBox(false);
        });
    } catch (error) {
      props.setMessage({ type: 1, content: t("serverError"), proceed: "Try Again", code: 500 });
      props.setLoaderBox(false);
    }
  };
  const setIsAcceptedHandler = (value) => {
    // setIsAccepted(value);
  };
  // useEffect(() => {
  //   // Dispatch action to fetch FAQ group if it doesn't exist
  //   if (!concerns?.data) {
  //     // Dispatch action to fetch FAQs for the first group in the list
  //     dispatch(fetchContactConcerns());
  //   }
  //   // Re-run the effect when dispatch or faqGroup changes
  // }, [dispatch, concerns]);
  // useEffect(() => {
  //   // props.setLoaderBox(false);

  //   if (selectedConcern && selectedConcern.reason?.length === 1 ? true : false) {
  //     setType(selectedConcern.reason[0]);
  //   }
  // }, [selectedConcern]);
  return (
    <RowContainer className="contact" style={{backgroundColor:"#f2f4fa"}}>

    <ContactTop>
      {/* <BackButton onClick={()=> navigate("/")}>
        <GetIcon icon={"left-arrow"} fontSize="30px" color="#3276C3" />
      </BackButton> */}
      <Page>
        <div style={{textAlign:'center',marginTop:'5px'}}>{t("CONTACT US")}</div>
        <Header style={{paddingTop:'5px'}} className={"contact"}>{t("We will answer your questions directly")}</Header>
        <div style={{textAlign:'center',padding:'5px 10px 0 10px'}}>{t("Someone from our team will contact you shortly.")}</div>
        {/* <ContactDetail>
          <div style={{display:'flex', flexDirection:'column', alignItems:'center',gap:'5px'}}>
            <GetIcon icon={"email"} fontSize="40px" color="#FFFFFF" />
            <div>{t("email")} {t("send")}</div>
            <div>{t("Write an email Call")}</div>
            <a href="mailto:info@whistleblowing24.com" style={{textDecoration: 'none'}}>
            <Button className="contact-header">
              <GetIcon icon={"email2"} fontSize="25px" color="#066db7" />
              <span style={{fontSize:'18px', fontWeight:'bold'}}>{t("email")}</span>
            </Button>
            </a>
          </div>
          <div style={{display:'flex', flexDirection:'column', alignItems:'center',gap:'5px'}}>
            <GetIcon icon={"phone"} fontSize="40px" color="#007bff" />
            <div>{t("Call us")}</div>
            <div>{t("mon")} - {t("fri")} &nbsp; 09:00 - 17:00</div>
            <a href="tel:+498131360180" style={{textDecoration: 'none'}}>
            <Button className="contact-header">
              <span style={{fontSize:'18px', fontWeight:'bold'}}>{t("+49 8131 360180")}</span>
            </Button>
            </a>
          </div>
        </ContactDetail> */}
      </Page>
    </ContactTop>

      {/* {type && isAccepted
        ? type.form && ( */}
            <Row >
              <AutoForm
                // useCaptcha={true}
                useCheckbox={true}
                description={type?.description}
                key={type?.description}
                formType={"post"}
                // header={t("contactForm")}
                formInput={attributes}
                submitHandler={submitChange}
                button={t("send")}
                isOpenHandler={setIsAcceptedHandler}
                isOpen={true}
                plainForm={""}
                logo={"not"}
                buttonStyle={"left"}
                login={"contact"}
                clearForm={clearForm}
              ></AutoForm>
            </Row>
          {/* )
        : null} */}
    </RowContainer>
  );
};

export default withLayout(Contact);
